import { Controller } from "@hotwired/stimulus"
import consumer from "../channels/consumer"

// Generic ActionCable subscription controller for list/index pages
// Subscribes on connect, unsubscribes on disconnect (Turbo-safe)
// Dispatches filtered messages as custom events for Alpine to handle
//
// Usage:
//   <div data-controller="list-subscription"
//        data-list-subscription-type-value="inspection"
//        data-list-subscription-additional-types-value='["person"]'
//        @list-subscription:message.window="handleInspectionUpdate($event.detail)"
//        @list-subscription:person-message.window="handlePersonUpdate($event.detail)">
//
export default class extends Controller {
  static values = {
    type: String,           // Primary message type to filter (e.g., "inspection", "tenancy", "enquiry")
    additionalTypes: Array  // Additional types to listen for (dispatched as separate events)
  }

  connect() {
    this.subscription = consumer.subscriptions.create(
      { channel: "DataUpdatesChannel" },
      {
        received: (message) => this.handleMessage(message)
      }
    )
  }

  disconnect() {
    this.subscription?.unsubscribe()
  }

  handleMessage(message) {
    // Check if it matches the primary type
    if (this.hasTypeValue && message.type === this.typeValue) {
      this.dispatch("message", { detail: message })
      return
    }

    // Check if it matches any additional types
    if (this.hasAdditionalTypesValue && this.additionalTypesValue.includes(message.type)) {
      // Dispatch with type-specific event name (e.g., "person-message")
      this.dispatch(`${message.type}-message`, { detail: message })
    }
  }
}
